import { Outlet } from "react-router-dom";

const SafetyWorkReportManagementPageLayout = () => {
    return (
        <><Outlet /></>
    );
};

export default SafetyWorkReportManagementPageLayout;
